import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { WkoHighchart } from "../WkoHighchart";
const getChartHeight = (categoryCount) => Math.max(200, categoryCount * 50 + 80);
const getChartOptions = (data) => ({
    chart: {
        type: "bar",
        height: getChartHeight(data.length),
        marginTop: 10,
        spacingLeft: 5,
        spacingRight: 5,
    },
    title: { text: undefined },
    xAxis: {
        categories: data.map((item) => item.BreachType),
        title: { text: undefined },
        labels: { style: { fontSize: "8pt" } },
        type: undefined,
    },
    yAxis: {
        min: 0,
        title: { text: "NC Days" },
        allowDecimals: false,
        endOnTick: false,
    },
    legend: {
        enabled: true,
        borderWidth: 0,
        layout: "horizontal",
        verticalAlign: "bottom",
        align: "center",
        itemStyle: { fontSize: "8pt" },
    },
    tooltip: {
        formatter: function () {
            return `<b>${this.series.name}</b><br/>${this.x}: ${this.y} days`;
        },
    },
    plotOptions: {
        bar: {
            dataLabels: { enabled: false },
            groupPadding: 0.1,
        },
    },
    exporting: { enabled: false },
    series: [
        {
            type: "bar",
            name: "Current Quarter",
            data: data.map((item) => item.CurrentQuarterNcCount),
        },
        {
            type: "bar",
            name: "Previous Quarter",
            data: data.map((item) => item.PreviousQuarterNcCount),
        },
    ],
});
export const BreachTypeNcChart = ({ options }) => {
    const [isFetching, setIsFetching] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [breachTypeNcs, setBreachTypeNcs] = useState([]);
    useEffect(() => {
        if (!options.isReady) {
            setIsFetching(false);
            setHasResult(false);
            setErrorMessage("");
            setBreachTypeNcs([]);
            return;
        }
        setIsFetching(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/operational/breachtypencs?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            if (data === null) {
                setBreachTypeNcs([]);
                setHasResult(true);
                return;
            }
            setBreachTypeNcs(Array.isArray(data) ? data : []);
            setHasResult(true);
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching breach type data");
        })
            .finally(() => setIsFetching(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const chartOptions = useMemo(() => getChartOptions(breachTypeNcs), [breachTypeNcs]);
    const isLoading = !options.isReady || isFetching;
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "NCs by breach type" }), _jsxs("div", { className: "card-body", children: [isLoading && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && breachTypeNcs.length > 0 && _jsx(WkoHighchart, { options: chartOptions }), hasResult && !isLoading && breachTypeNcs.length === 0 && !errorMessage && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
};
